<template>
<div>
    <div v-if="Orders">
        <div class="acr-welcome-message">
            <h3>سفارشات من</h3>
        </div>
        <div class="checkout-table">
            <!-- table Start  -->
            <table class="mb-0c products_table" id="productList">
                <thead class="center">
                    <tr>
                        <th>کد سفارش</th>
                        <th>تاریخ سفارش</th>
                        <th>وضعیت سفارش</th>
                        <th>مبلغ سفارش</th>
                        <th>عملیات</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="product" v-for="(Item,Index) in Orders" :key="Index">
                        <td class="center" data-title='کد سفارش '>{{Orders[Index].id}}</td>
                        <td class="center" data-title='تاریخ سفارش '>{{Orders[Index].caj}}</td>
                        <td class="center" data-title='وضعیت سفارش '>
                            <span>
                                <div class="state product-order-status vs-chip-primary con-color" style="color: rgba(255, 255, 255, 0.9);">
                                    <span class="text-chip vs-chip--text">{{Orders[Index].sts_str}}</span>
                                </div>
                            </span>
                        </td>
                        <td class="center"  data-title='مبلغ سفارش '>
                            {{ Orders[Index].total_price | priceUnit}}
                        </td>
                        <td class="center"  data-title='عملیات '>
                            <div @click="Check_Index(Index)" class="btn-custom secondary">مشاهده جزئیات</div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- table end  -->
        </div>

        <pagination
        v-model="page"
        :total-pages="Math.ceil(count/limit)"
        @pagechanged="onPageChange" />
        <modal v-model="model">
            <template v-slot:header>
                جزییات سفارش شماره {{Orders[Order_Index].id}}
            </template>
            <template v-slot:body>
                <div class="vs-popup--content popup-example">
                    <div class="flex flex-wrap">
                        <div class="text-right mb-4 w-1/3">
                            <div class="title">شماره سفارش</div>
                            <div class="value">
                                {{Orders[Order_Index].id}}
                            </div>
                        </div>
                        <div class="text-right mb-4 w-1/3">
                            <div class="title">مبلغ سفارش</div>
                            <div class="value">{{ Orders[Order_Index].total_price | priceUnit}}</div>
                        </div>
                        <div class="text-right mb-4 w-1/3">
                            <div class="title">زمان ثبت سفارش</div>
                            <div class="value">{{Orders[Order_Index].uaj}}</div>
                        </div>
                        <div class="text-right mb-4 w-1/3">
                            <div class="title">وضعیت سفارش</div>
                            <div class="value">{{Orders[Order_Index].sts_str}}</div>
                        </div>
                    </div>
                    <div class="vs-component vs-divider center" title="ایتم های سفارش">
                        <span class="vs-divider-border after vs-divider-border-default" style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1)"></span>
                        <span class="vs-divider-border before vs-divider-border-default" style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1)"></span>
                    </div>
                    <div class="vs-component vs-con-table vs-table-primary">
                        <header class="header-table vs-table--header">
                            <h3>آیتم های سفارش</h3>

                        </header>
                        <div class="con-tablex vs-table--content">
                            <div class="vs-con-tbody vs-table--tbody">

                                <!-- start table -->
                                <table class="vs-table vs-table--tbody-table">
                                    <thead class="vs-table--thead">
                                    <tr>
                                        <th colspan="1" rowspan="1">
                                                شماره ردیف
                                        </th>
                                        <th colspan="1" rowspan="1">
                                                نام محصول
                                        </th>
                                        <th colspan="1" rowspan="1">
                                                تنوع
                                        </th>
                                        <th colspan="1" rowspan="1">
                                                تعداد
                                        </th>
                                        <th colspan="1" rowspan="1">
                                                قیمت
                                        </th>
                                        <th colspan="1" rowspan="1">
                                                گرم
                                        </th>
                                    </tr>
                                    </thead>

                                    <!-- loop -->
                                    <tr v-for="(Order,Item) in Orders[Order_Index].items" :key='Item' class="tr-values vs-table--tr tr-table-state-null">
                                        <td class="td vs-table--td">
                                    <span>
                                        {{Show_Index(Item)}}
                                    </span>
                                        </td>
                                        <td class="td vs-table--td">
                                    <span>
                                        {{Orders[Order_Index].items[Item].title}}
                                    </span>
                                        </td>
                                        <td class="td vs-table--td">
                                    <span>
                                        {{Orders[Order_Index].items[Item].variant_title}}
                                    </span>
                                        </td>
                                        <td class="td vs-table--td">
                                    <span>
                                        {{Orders[Order_Index].items[Item].qty}}
                                    </span>
                                        </td>
                                        <td class="td vs-table--td">
                                    <span>
                                        {{ Orders[Order_Index].items[Item].price | priceUnit}}
                                    </span>
                                        </td>
                                        <td class="td vs-table--td">
                                    <span>
                                        {{Orders[Order_Index].items[Item].grams}}
                                    </span>
                                        </td>
                                    </tr>
                                    <!-- loop -->

                                </table>
                                <!-- end table -->

                            </div>
                        </div>
                    </div>
                    <div class="vs-component vs-divider">
                        <span class="vs-divider-border after vs-divider-border-default" style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1)">
                        </span>
                        <span class="vs-divider-border before vs-divider-border-default" style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1)"></span>
                    </div>
                    <div>
                        <h5 class="mb-4">آدرس ارسال</h5>
                        <div class="flex flex-wrap">
                            <div class="text-right mb-4 w-1/3">
                                <div class="title">استان</div>
                                <div class="value">{{Orders[Order_Index].shipping_address.province}}</div>
                            </div>
                            <div class="text-right mb-4 w-1/3">
                                <div class="title">شهر</div>
                                <div class="value">{{Orders[Order_Index].shipping_address.city}}</div>
                            </div>
                            <div class="text-right mb-4 w-1/3">
                                <div class="title">کد پستی</div>
                                <div class="value">{{Orders[Order_Index].shipping_address.zipcode}}</div>
                            </div>
                            <div class="text-right mb-4 w-1/3">
                                <div class="title">تلفن</div>
                                <div class="value">{{Orders[Order_Index].shipping_address.reciver_phone}}</div>
                            </div>
                            <div class="text-right mb-4 w-1/3">
                                <div class="title">نام و نام خانوادگی</div>
                                <div class="value">{{Orders[Order_Index].shipping_address.reciver_fname}}</div>
                            </div>
                            <div class="text-right mb-4 w-1/3">
                                <div class="title">تلفن ثابت</div>
                                <div class="value">{{Orders[Order_Index].shipping_address.reciver_fixed_phone}}</div>
                            </div>
                            <div class="text-right mb-4 w-1/3">
                                <div class="title">آدرس</div>
                                <div class="value">
                                    {{Orders[Order_Index].shipping_address.address}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </modal>

    </div>
    <div v-if="flag">
        <img style="max-width: 400px;margin: auto;display: block;" src="@/assets/images/nofound.svg" />
        <h5 style="text-align: center">موردی یافت نشد</h5>
    </div>
</div>
</template>

<script>
import Pagination from "@/components/Pagination";
import modal from "@/components/modal";
import axios from '@/plugins/axios'
export default {
    props:{
        togglePreLoader: Function
    },
    components:{
        Pagination,
        modal,
    },
    data () {
        return {
          page: 1,
          limit:5,
          count: null,
          Orders: undefined,
          Order_Index: 0,
          Items: null,
          Error: null,
          model:false,
          flag:false
        }
    },
    watch:{
      Orders(value){
        if(value.length<1){
          this.flag = true
        }
      }
    },
    methods: {
        async onPageChange(){
            try {
              this.togglePreLoader('open')
              let {data} = await axios.post(`/cu/order/table`,{page:this.page,limit:this.limit})
              this.Orders = data.rows
            } catch (error) {
              if (error.response && error.response.data.errors) {
                let str_error = ''
                for(let item of Object.values(error.response.data.errors))
                {
                  item.map(xx=>{
                    if (xx.includes("shipping address")){
                      str_error += xx.replace("shipping address","آدرس") + "<br/>"
                    }
                    else{
                      str_error += xx + "<br/>"
                    }
                  })
                }
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
              }
              else{
                if (error) {
                  if(error == "Error: Network Error"){
                    this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
                  }
                  else {
                    this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
                  }
                }
              }
            } finally {
              this.togglePreLoader('close')
            }
            let el = document.getElementById('productList')
            document.body.scrollTop = el.offsetTop - 150;
            document.documentElement.scrollTop = el.offsetTop - 150;
        },
        Check_Index (Index) {
            this.Order_Index = Index
            this.Items = this.Orders[Index].items
            this.model = true
        },
        Show_Index (Item) {
            return ++Item
        }
    },
    async created () {
      try {
            this.togglePreLoader('open')
            let {data} = await axios.post(`/cu/order/table`,{page:this.page,limit:this.limit})
            this.Orders = data.rows
            this.count = data.query.total
        } catch (error) {
          if (error.response && error.response.data.errors) {
            let str_error = ''
            for(let item of Object.values(error.response.data.errors))
            {
              item.map(xx=>{
                if (xx.includes("shipping address")){
                  str_error += xx.replace("shipping address","آدرس") + "<br/>"
                }
                else{
                  str_error += xx + "<br/>"
                }
              })
            }
            this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
          }
          else{
            if (error) {
              if(error == "Error: Network Error"){
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
              }
              else {
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
              }
            }
          }
          } finally {
            this.togglePreLoader('close')
        }
    }
}
</script>

<style>
.vs-chip-primary:not(.bg-chip-transparent) {
    margin: auto;
    width: 90px;
}
.state {
    display: flex;
    align-items: center;
    font-size: .7rem;
    border-radius: 8px;
    justify-content: center;
    min-height: 28px;
    position: relative;
    margin: auto;
}
.state span {
    margin: 0 !important;
}
.vs-chip-primary:not(.bg-chip-transparent) {
    background: var(--secondary-color);
}
</style>
